module.exports = __webpack_public_path__ + "img/zimmer-frei-5.072d55f0.jpg";